module.exports = __webpack_public_path__ + "static/media/user-shield.93ee9b78.svg";